// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EServicesResponses {
    'pcfHasInsuranceResponse'?: string | null;
    'fasWithinFplResponse'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesResponses>> = [
        {
            "name":     "pcfHasInsuranceResponse",
            "baseName": "pcfHasInsuranceResponse",
            "type":     "string"
        },
        {
            "name":     "fasWithinFplResponse",
            "baseName": "fasWithinFplResponse",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesResponses.attributeTypeMap;
    }
}
